<div>
  <div class="artist-wrapper">
    <div *ngFor="let artist of artists" [class]="artistInfo.id !== artist.id ? 'artist-list-item' : 'artist-detail-item'" >
      <a  *ngIf="artistInfo.id !== artist.id" (click)="showMore(artist)">
        <div class="artist-thumb" [style.background-image]="'url(' + musicDBapiSrc + '/coverArt/300/' + artist.id  + '/artist), url(/assets/no-photo.svg)'" ></div>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <a [routerLink]="'/releases/artists/' + artist.id" (click)="clear()">{{artist.name}}</a>
          <div>
            <mat-icon *ngIf="artist.cont_ausnz === 'A'" svgIcon="australian"></mat-icon>
            <mat-icon *ngIf="artist.cont_local" svgIcon="local"></mat-icon>
            <mat-icon *ngIf="artist.cont_female === 'F'" svgIcon="female"></mat-icon>
          </div>
        </div>
      </a>
      
      <div *ngIf="artistInfo.id === artist.id">
        <a [routerLink]="'/releases/artists/' + artist.id" (click)="clear()">
          <img onerror="this.src='/assets/no-photo.svg'" class="artist-photo" [src]="musicDBapiSrc + '/coverArt/1000/' + artistInfo.id  + '/artist'" />
          <h3>{{artist.name}}</h3>
        </a>
        <div class="genres"><span class="tag" *ngFor="let genre of artistInfo.genres">{{genre}}</span></div>
        <div class="artist-bio">{{artistInfo.bio}}</div>
        <app-cover-player [showYear]="true" [releases]="artistInfo.releases" [release]="click" [play]="play" [queue]="queueRelease" [favourite]="favourite"></app-cover-player>

      </div>
    </div>
  </div>
</div>
